<template>
    <a-drawer width="80%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @close="onClose">
        <a-divider orientation="left">
            <b>{{ formTitle }}</b>
        </a-divider>
        <a-form-model ref="form" :model="form" :rules="rules">

            <a-form-model-item label="文案" prop="title">
                <a-input v-model="form.title" allow-clear />
            </a-form-model-item>

            <a-form-model-item label="英文文案" prop="titleEn">
                <a-input v-model="form.titleEn" allow-clear />
            </a-form-model-item>

            <a-form-model-item label="日语文案" prop="titleJa">
                <a-input v-model="form.titleJa" allow-clear />
            </a-form-model-item>

            <a-form-model-item label="印尼文案" prop="titleId">
                <a-input v-model="form.titleId" allow-clear />
            </a-form-model-item>

            <a-form-model-item label="葡语文案" prop="titlePt">
                <a-input v-model="form.titlePt" allow-clear />
            </a-form-model-item>

            <a-form-model-item label="西语文案" prop="titleEs">
                <a-input v-model="form.titleEs" allow-clear />
            </a-form-model-item>

            <a-form-model-item label="弹窗类型" prop="type">
                <a-select v-model="form.type" placeholder="请选择">
                    <a-select-option :value="1">会员付费</a-select-option>
                    <a-select-option :value="2">金币领取</a-select-option>
                    <a-select-option :value="3">内容弹窗</a-select-option>
                    <a-select-option :value="4">优惠弹窗</a-select-option>
                    <a-select-option :value="5">外链弹窗</a-select-option>
                </a-select>
            </a-form-model-item>

            <div v-if="form.type === 1">
                <a-form-model-item label="赠送VIP天数" prop="giveVipCount">
                    <a-input-number v-model="form.giveVipCount" :min="0" />
                </a-form-model-item>
            </div>

            <div v-if="form.type === 2">
                <a-form-model-item label="赠送金币数量" prop="giveCoinsCount">
                    <a-input-number v-model="form.giveCoinsCount" :min="0" />
                </a-form-model-item>
            </div>

            <div v-if="form.type === 3 || form.type === 4">
                <a-form-model-item label="倒计时(秒)" prop="countdown">
                    <a-input-number v-model="form.countdown" :min="0" />
                </a-form-model-item>
            </div>

            <div v-if="form.type === 3">
                <a-form-model-item label="跳转的剧集" prop="videoId">
                    <a-select v-model="form.videoId" placeholder="请选择剧集" allowClear>
                        <a-select-option v-for="(video, index) in videoList" :key="index" :value="video.id">
                            {{ video.videoName }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </div>

            <div v-if="form.type === 5">
                <a-form-model-item label="链接URL" prop="linkUrl">
                    <a-input v-model="form.linkUrl" :min="0" />
                </a-form-model-item>
                <a-form-model-item label="链接类型" prop="linkType">
                    <a-select v-model="form.linkType" placeholder="请选择">
                        <a-select-option :value="1">外链</a-select-option>
                        <a-select-option :value="2">内连</a-select-option>
                        <a-select-option :value="3">深度链接</a-select-option>
                    </a-select>
                </a-form-model-item>
            </div>

            <!-- <div v-if="form.type === 4">
                <a-form-model-item label="优惠VIP类型(周月年季)" prop="windowRecommendVipType">
                    <a-select v-model="form.windowRecommendVipType" placeholder="请选择" allowClear>
                        <a-select-option :value="1">周卡</a-select-option>
                        <a-select-option :value="2">月卡</a-select-option>
                        <a-select-option :value="4">季卡</a-select-option>
                        <a-select-option :value="3">年卡</a-select-option>
                    </a-select>
                </a-form-model-item>
            </div> -->

            <a-form-model-item label="弹出次数" prop="popCount">
                <a-input v-model="form.popCount" allow-clear />
            </a-form-model-item>

            <a-form-model-item label="用户VIP时长（天）" prop="userVip">
                <a-input v-model="form.userVip" allow-clear />
            </a-form-model-item>

            <a-form-model-item label="用户金币余额（个）" prop="userCoins">
                <a-input v-model="form.userCoins" allow-clear />
            </a-form-model-item>

            <a-form-model-item label="解锁弹窗退出次数" prop="unlockWindowExitCount">
                <a-input v-model="form.unlockWindowExitCount" allow-clear />
            </a-form-model-item>
            <a-form-model-item label="国家代码" prop="countryCodeList">
                <a-select v-model="form.countryCodeList" mode="multiple" placeholder="请选择国家代码" allowClear
                    style="width: 100%">
                    <a-select-option v-for="(code, index) in countryCodeList" :key="index" :value="code">
                        {{ code }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="用户状态" prop="userActive">
                <a-select v-model="form.userActive" placeholder="请选择" allowClear>
                    <a-select-option :value="1">用户连续活跃</a-select-option>
                    <a-select-option :value="2">用户累计活跃</a-select-option>
                </a-select>
            </a-form-model-item>

            <div v-if="form.userActive === 1">
                <a-form-model-item label="连续活跃天数" prop="activeDays">
                    <a-input-number v-model="form.activeDays" :min="0" />
                </a-form-model-item>
            </div>

            <div v-if="form.userActive === 2">
                <a-form-model-item label="用户累计活跃天数" prop="activeSum">
                    <a-input-number v-model="form.activeSum" :min="0" />
                </a-form-model-item>
            </div>

            <a-form-model-item label="场景" prop="scene">
                <a-select v-model="form.scene" placeholder="请选择场景" @change="handleSceneChange">
                    <a-select-option :value="1">首页</a-select-option>
                    <a-select-option :value="2">播放页</a-select-option>
                    <a-select-option :value="3">瀑布流</a-select-option>
                    <a-select-option :value="4">我的</a-select-option>
                    <a-select-option :value="5">会员</a-select-option>
                    <a-select-option :value="6">钱包</a-select-option>
                    <a-select-option :value="7">福利页</a-select-option>
                </a-select>
            </a-form-model-item>

            <!-- 首页 -->
            <!-- <div v-if="form.scene === 1">
                <a-form-model-item label="每次启动" prop="startCount">
                    <a-input-number v-model="form.sceneData.startCount" :min="0" />
                </a-form-model-item>
                <a-form-model-item label="停留时长(秒)" prop="homeStayDuration">
                    <a-input-number v-model="form.sceneData.stayDuration" :min="0" />
                </a-form-model-item>
                <a-form-model-item label="下划次数" prop="scrollCount">
                    <a-input-number v-model="form.sceneData.scrollCount" :min="0" />
                </a-form-model-item>
            </div> -->
            <div v-if="form.scene === 1">
                <a-form-model-item label="每次启动">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.startCountOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.startCount" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>

                <a-form-model-item label="停留时长(秒)">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.stayDurationOp" style="width:80px">
                            <!-- <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option> -->
                            <a-select-option value="=">=</a-select-option>
                            <!-- <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option> -->
                        </a-select>
                        <a-input-number v-model="form.sceneData.stayDuration" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>

                <a-form-model-item label="下划次数">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.scrollCountOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.scrollCount" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>
            </div>

            <!-- 播放页 -->
            <!-- <div v-if="form.scene === 2">
                <a-form-model-item label="剧集名称" prop="videoId">
                    <a-select v-model="form.sceneData.videoId" placeholder="请选择剧集" allowClear>
                        <a-select-option v-for="(video, index) in videoList" :key="index" :value="video.id">
                            {{ video.videoName }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="观看集数" prop="watchedEpisodes">
                    <a-input-number v-model="form.sceneData.watchedEpisodes" :min="0" />
                </a-form-model-item>
                <a-form-model-item label="完播集数" prop="completedEpisodes">
                    <a-input-number v-model="form.sceneData.completedEpisodes" :min="0" />
                </a-form-model-item>
                <a-form-model-item label="广告解锁次数" prop="adUnlockCount">
                    <a-input-number v-model="form.sceneData.adUnlockCount" :min="0" />
                </a-form-model-item>
                <a-form-model-item label="退出次数" prop="exitCount">
                    <a-input-number v-model="form.sceneData.exitCount" :min="0" />
                </a-form-model-item>
                <a-form-model-item label="观看广告中途退出次数" prop="adExitCount">
                    <a-input-number v-model="form.sceneData.adExitCount" :min="0" />
                </a-form-model-item>
            </div> -->
            <div v-if="form.scene === 2">

                <a-form-model-item label="剧集名称">
                    <a-select v-model="form.sceneData.videoId" placeholder="请选择剧集" allowClear>
                        <a-select-option v-for="(video, index) in videoList" :key="index" :value="video.id">{{
                            video.videoName }}</a-select-option>
                    </a-select>
                </a-form-model-item>

                <a-form-model-item label="观看集数">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.watchedEpisodesOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.watchedEpisodes" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>

                <a-form-model-item label="完播集数">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.completedEpisodesOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.completedEpisodes" :min="0"
                            style="margin-left:10px" />
                    </div>
                </a-form-model-item>

                <a-form-model-item label="广告解锁次数">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.adUnlockCountOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.adUnlockCount" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>

                <a-form-model-item label="退出次数">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.exitCountOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.exitCount" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>

                <a-form-model-item label="广告中途退出次数">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.adExitCountOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.adExitCount" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>
            </div>
            <!-- 瀑布流 -->
            <!-- <div v-if="form.scene === 3">
                <a-form-model-item label="下划次数" prop="scrollCount">
                    <a-input-number v-model="form.sceneData.scrollCount" :min="0" />
                </a-form-model-item>
                <a-form-model-item label="观看时长(秒)" prop="watchDuration">
                    <a-input-number v-model="form.sceneData.watchDuration" :min="0" />
                </a-form-model-item>
            </div> -->
            <div v-if="form.scene === 3">
                <a-form-model-item label="下划次数">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.scrollCountOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.scrollCount" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>

                <a-form-model-item label="观看时长(秒)">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.watchDurationOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.watchDuration" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>
            </div>


            <!-- 我的 -->
            <!-- <div v-if="form.scene === 4">
                <a-form-model-item label="打开次数" prop="openCount">
                    <a-input-number v-model="form.sceneData.openCount" :min="0" />
                </a-form-model-item>
                <a-form-model-item label="停留时长(秒)" prop="stayDuration">
                    <a-input-number v-model="form.sceneData.stayDuration" :min="0" />
                </a-form-model-item>
            </div> -->
            <div v-if="form.scene === 4">
                <a-form-model-item label="打开次数">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.openCountOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.openCount" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>

                <a-form-model-item label="停留时长(秒)">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.stayDurationOp" style="width:80px">
                            <!-- <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option> -->
                            <a-select-option value="=">=</a-select-option>
                            <!-- <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option> -->
                        </a-select>
                        <a-input-number v-model="form.sceneData.stayDuration" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>
            </div>



            <!-- 会员 -->
            <!-- <div v-if="form.scene === 5">
                <a-form-model-item label="打开次数" prop="openCount">
                    <a-input-number v-model="form.sceneData.openCount" :min="0" />
                </a-form-model-item>
                <a-form-model-item label="停留时长(秒)" prop="stayDuration">
                    <a-input-number v-model="form.sceneData.stayDuration" :min="0" />
                </a-form-model-item>
                <a-form-model-item label="退出次数" prop="exitCount">
                    <a-input-number v-model="form.sceneData.exitCount" :min="0" />
                </a-form-model-item>
            </div> -->

            <div v-if="form.scene === 5">
                <a-form-model-item label="打开次数">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.openCountOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.openCount" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>

                <a-form-model-item label="停留时长(秒)">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.stayDurationOp" style="width:80px">
                            <!-- <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option> -->
                            <a-select-option value="=">=</a-select-option>
                            <!-- <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option> -->
                        </a-select>
                        <a-input-number v-model="form.sceneData.stayDuration" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>

                <a-form-model-item label="退出次数">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.exitCountOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.exitCount" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>
            </div>



            <!-- 钱包 -->
            <!-- <div v-if="form.scene === 6">
                <a-form-model-item label="打开次数" prop="openCount">
                    <a-input-number v-model="form.sceneData.openCount" :min="0" />
                </a-form-model-item>
                <a-form-model-item label="停留时长(秒)" prop="stayDuration">
                    <a-input-number v-model="form.sceneData.stayDuration" :min="0" />
                </a-form-model-item>
            </div> -->
            <div v-if="form.scene === 6">
                <a-form-model-item label="打开次数">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.openCountOp" style="width:80px">
                            <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option>
                            <a-select-option value="=">=</a-select-option>
                            <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option>
                        </a-select>
                        <a-input-number v-model="form.sceneData.openCount" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>

                <a-form-model-item label="停留时长(秒)">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.stayDurationOp" style="width:80px">
                            <!-- <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option> -->
                            <a-select-option value="=">=</a-select-option>
                            <!-- <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option> -->
                        </a-select>
                        <a-input-number v-model="form.sceneData.stayDuration" :min="0" style="margin-left:10px" />
                    </div>
                </a-form-model-item>
            </div>



            <!-- 福利页 -->
            <!-- <div v-if="form.scene === 7">
                <a-form-model-item label="停留时长(秒)" prop="rewardStayDuration">
                    <a-input-number v-model="form.sceneData.rewardStayDuration" :min="0" />
                </a-form-model-item>
            </div> -->
            <div v-if="form.scene === 7">
                <a-form-model-item label="停留时长(秒)">
                    <div class="op-input">
                        <a-select v-model="form.sceneData.rewardStayDurationOp" style="width:80px">
                            <!-- <a-select-option value="&lt;">&lt;</a-select-option>
                            <a-select-option value="&lt;=">&lt;=</a-select-option> -->
                            <a-select-option value="=">=</a-select-option>
                            <!-- <a-select-option value="&gt;=">&gt;=</a-select-option>
                            <a-select-option value="&gt;">&gt;</a-select-option> -->
                        </a-select>
                        <a-input-number v-model="form.sceneData.rewardStayDuration" :min="0"
                            style="margin-left:10px" />
                    </div>
                </a-form-model-item>
            </div>



            <a-form-model-item label="是否启用（同场景的弹窗只能开启一个）" prop="status" allowClear>
                <a-select v-model="form.status">
                    <a-select-option :value="0">启用</a-select-option>
                    <a-select-option :value="1">禁用</a-select-option>
                </a-select>
            </a-form-model-item>


            <a-form-model-item label="中文图" prop="imgUrl">
                <a-upload listType="picture-card" class="avatar-uploader" v-model="form.imgUrl" :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload"
                    :customRequest="handleChange">
                    <plus-outlined />
                    <img v-if="form.imgUrl" :src="form.imgUrl" alt="logo" style="height:104px;max-width:300px" />
                    <div v-else>
                        <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-model-item>
            <a-form-model-item label="英文图" prop="imgUrlEn">
                <a-upload listType="picture-card" class="avatar-uploader" v-model="form.imgUrlEn" :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload1"
                    :customRequest="handleChange1">
                    <plus-outlined />
                    <img v-if="form.imgUrlEn" :src="form.imgUrlEn" alt="logo" style="height:104px;max-width:300px" />
                    <div v-else>
                        <a-icon :type="uploadLoading1 ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-model-item>
            <a-form-model-item label="日语图" prop="imgUrlJa">
                <a-upload listType="picture-card" class="avatar-uploader" v-model="form.imgUrlJa" :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload2"
                    :customRequest="handleChange2">
                    <plus-outlined />
                    <img v-if="form.imgUrlJa" :src="form.imgUrlJa" alt="logo" style="height:104px;max-width:300px" />
                    <div v-else>
                        <a-icon :type="uploadLoading1 ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-model-item>

            <a-form-model-item label="印尼图" prop="imgUrlId">
                <a-upload listType="picture-card" class="avatar-uploader" v-model="form.imgUrlId" :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload3"
                    :customRequest="handleChange3">
                    <plus-outlined />
                    <img v-if="form.imgUrlId" :src="form.imgUrlId" alt="logo" style="height:104px;max-width:300px" />
                    <div v-else>
                        <a-icon :type="uploadLoading3 ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-model-item>

            <a-form-model-item label="葡语图" prop="imgUrlPt">
                <a-upload listType="picture-card" class="avatar-uploader" v-model="form.imgUrlPt" :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload4"
                    :customRequest="handleChange4">
                    <plus-outlined />
                    <img v-if="form.imgUrlPt" :src="form.imgUrlPt" alt="logo" style="height:104px;max-width:300px" />
                    <div v-else>
                        <a-icon :type="uploadLoading4 ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-model-item>

            <a-form-model-item label="西语图" prop="imgUrlEs">
                <a-upload listType="picture-card" class="avatar-uploader" v-model="form.imgUrlEs" :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos" :beforeUpload="beforeUpload5"
                    :customRequest="handleChange5">
                    <plus-outlined />
                    <img v-if="form.imgUrlEs" :src="form.imgUrlEs" alt="logo" style="height:104px;max-width:300px" />
                    <div v-else>
                        <a-icon :type="uploadLoading5 ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">上传</div>
                    </div>
                </a-upload>
            </a-form-model-item>

            <div class="bottom-control">
                <a-space>
                    <a-button type="primary" :loading="submitLoading" @click="submitForm">
                        保存
                    </a-button>
                    <a-button type="dashed" @click="cancel">
                        取消
                    </a-button>
                </a-space>
            </div>
        </a-form-model>
    </a-drawer>
</template>
  
<script>
import { detail, add, update } from '@/api/popWindow/popWindow'
import { getUserCountryCode } from '@/api/biz/user'
import Editor from '@/components/Editor'
import UploadFileToVOD from "@/api/vod.js"
import { listVideo } from "@/api/video/video";

export default {
    name: 'CreateForm',
    props: {
    },
    components: {
        Editor
    },
    data() {
        return {
            submitLoading: false,
            uploadLoading: false,
            uploadLoading1: false,
            uploadLoading2: false,
            uploadLoading3: false,
            uploadLoading4: false,
            uploadLoading5: false,
            formTitle: '',
            open: false,
            countryCodeList: [],
            form: {
                title: null,
                titleEn: null,
                titleJa: null,
                titleId: null,
                titlePt: null,
                titleEs: null,
                popCount: null,
                imgUrl: null,
                imgUrlE: null,
                imgUrlJa: null,
                imgUrlId: null,
                imgUrlPt: null,
                imgUrlEs: null,
                scene: null,
                giveCoinsCount: null,
                type: null,
                giveVipCount: null,
                unlockWindowExitCount: null,
                countryCode: null,
                userVip: null,
                userCoins: null,
                userActive: null,
                activeDays: null,
                activeSum: null,
                videoId: null,
                linkUrl: null,
                linkType: null,
                status: 1,
                sceneData: {},
                countdown: null,
                // 播放页字段
                videoList: [],
                countryCodeList: [],
                windowRecommendVipType: null
            },
            rules: {
                title: [{ required: true, message: '请输入繁中文案', trigger: 'change' }],
                titleEn: [{ required: true, message: '请输入英文文案', trigger: 'change' }],
                titleJa: [{ required: true, message: '请输入日语文案', trigger: 'change' }],
                popCount: [{ required: true, message: '请输入弹出次数', trigger: 'change' }],
                scene: [{ required: true, message: '请选择场景', trigger: 'change' }],
                type: [{ required: true, message: '请选择弹窗类型', trigger: 'change' }],
                sceneData: [{ required: true, message: '请选择场景参数', trigger: 'change' }],
            }
        }
    },
    filters: {
    },
    created() {
        this.queryVideoList()
        this.queryUserCountryCodeList()
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        handleSceneChange(sceneType) {
            this.form.sceneData = {};

            switch (sceneType) {
                case 1: // 首页
                    this.form.sceneData = {
                        startCountOp: "=",
                        startCount: 1,
                        stayDurationOp: "=",
                        stayDuration: 1,
                        scrollCountOp: "=",
                        scrollCount: 1
                    };
                    break;

                case 2: // 播放页
                    this.form.sceneData = {
                        videoId: undefined,
                        watchedEpisodesOp: "=",
                        watchedEpisodes: 0,
                        completedEpisodesOp: "=",
                        completedEpisodes: 0,
                        adUnlockCountOp: "=",
                        adUnlockCount: 0,
                        exitCountOp: "=",
                        exitCount: 1,
                        adExitCountOp: "=",
                        adExitCount: 1
                    };
                    break;

                case 3: // 瀑布流
                    this.form.sceneData = {
                        scrollCountOp: "=",
                        scrollCount: 0,
                        watchDurationOp: "=",
                        watchDuration: 0
                    };
                    break;

                case 4: // 我的
                    this.form.sceneData = {
                        openCountOp: "=",
                        openCount: 0,
                        stayDurationOp: "=",
                        stayDuration: 0
                    };
                    break;

                case 5: // 会员
                    this.form.sceneData = {
                        openCountOp: "=",
                        openCount: 1,
                        stayDurationOp: "=",
                        stayDuration: 1,
                        exitCountOp: "=",
                        exitCount: 1
                    };
                    break;

                case 6: // 钱包
                    this.form.sceneData = {
                        openCountOp: "=",
                        openCount: 0,
                        stayDurationOp: "=",
                        stayDuration: 0
                    };
                    break;

                case 7: // 福利页
                    this.form.sceneData = {
                        rewardStayDurationOp: "=",
                        rewardStayDuration: 0
                    };
                    break;

                default:
                    this.form.sceneData = {};
            }
        },
        handleChange(info) {

            let that = this
            new UploadFileToVOD([info.file], {
                success: function (fileName) {
                    that.form.imgUrl = fileName[0];//文件名
                    that.uploadLoading = false;
                },

            });
            that.uploadLoading = false;

        },
        handleChange1(info) {

            let that = this
            new UploadFileToVOD([info.file], {
                success: function (fileName) {
                    that.form.imgUrlEn = fileName[0];//文件名
                    that.uploadLoading1 = false;
                },

            });
            that.uploadLoading1 = false;

        },
        handleChange2(info) {

            let that = this
            new UploadFileToVOD([info.file], {
                success: function (fileName) {
                    that.form.imgUrlJa = fileName[0];//文件名
                    that.uploadLoading2 = false;
                },

            });
            that.uploadLoading2 = false;

        },

        handleChange3(info) {

            let that = this
            new UploadFileToVOD([info.file], {
                success: function (fileName) {
                    that.form.imgUrlId = fileName[0];//文件名
                    that.uploadLoading3 = false;
                },

            });
            that.uploadLoading3 = false;

        },

        handleChange4(info) {

            let that = this
            new UploadFileToVOD([info.file], {
                success: function (fileName) {
                    that.form.imgUrlPt = fileName[0];//文件名
                    that.uploadLoading4 = false;
                },

            });
            that.uploadLoading4 = false;

        },

        handleChange5(info) {

            let that = this
            new UploadFileToVOD([info.file], {
                success: function (fileName) {
                    that.form.imgUrlEs = fileName[0];//文件名
                    that.uploadLoading5 = false;
                },

            });
            that.uploadLoading5 = false;

        },

        beforeUpload: function (file) {
            var fileType = file.type;
            if (fileType.indexOf('image') < 0) {
                this.$message.warning('请上传图片');
                this.uploadLoading = false
                return false;
            }
            this.form.imgUrl = ""
            //TODO 驗證文件大小
        },
        beforeUpload1: function (file) {
            var fileType = file.type;
            if (fileType.indexOf('image') < 0) {
                this.$message.warning('请上传图片');
                this.uploadLoading1 = false
                return false;
            }
            this.form.imgUrlEn = ""
            //TODO 驗證文件大小
        },
        beforeUpload2: function (file) {
            var fileType = file.type;
            if (fileType.indexOf('image') < 0) {
                this.$message.warning('请上传图片');
                this.uploadLoading2 = false
                return false;
            }
            this.form.imgUrlJa = ""
            //TODO 驗證文件大小
        },

        beforeUpload3: function (file) {
            var fileType = file.type;
            if (fileType.indexOf('image') < 0) {
                this.$message.warning('请上传图片');
                this.uploadLoading3 = false
                return false;
            }
            this.form.imgUrlId = ""
            //TODO 驗證文件大小
        },

        beforeUpload4: function (file) {
            var fileType = file.type;
            if (fileType.indexOf('image') < 0) {
                this.$message.warning('请上传图片');
                this.uploadLoading4 = false
                return false;
            }
            this.form.imgUrlPt = ""
            //TODO 驗證文件大小
        },

        beforeUpload5: function (file) {
            var fileType = file.type;
            if (fileType.indexOf('image') < 0) {
                this.$message.warning('请上传图片');
                this.uploadLoading5 = false
                return false;
            }
            this.form.imgUrlEs = ""
            //TODO 驗證文件大小
        },
        queryVideoList() {
            const param = {}
            listVideo(param).then(response => {
                this.videoList = response.data
            })
        },
        queryUserCountryCodeList() {
            const param = {}
            getUserCountryCode(param).then(response => {
                this.countryCodeList = response.data
            })
        },
        onClose() {
            this.open = false
            this.$emit('ok')
            this.reset()
        },
        // 取消按钮
        cancel() {
            this.open = false
            this.reset()
            this.$emit('ok')
        },
        // 表单重置
        reset() {
            this.formType = 1
            this.form = {
                countryCodeList: [],
                type: null,
                scene: null,
                title: null,
                titleEn: null,
                titleJa: null,
                titleId: null,
                titlePt: null,
                titleEs: null,
                popCount: null,
                imgUrl: null,
                imgUrlE: null,
                imgUrlJa: null,
                imgUrlId: null,
                imgUrlPt: null,
                imgUrlEs: null,
                giveVipCount: null,
                giveVipCount: null,
                userVip: null,
                userCoins: null,
                userActive: null,
                activeDays: null,
                activeSum: null,
                status: 1,
                videoId: null,
                linkUrl: null,
                unlockWindowExitCount: null,
                countryCode: null,
                linkType: null,
                sceneType: null,
                sceneData: {},
                countdown: null,
                windowRecommendVipType: null
            }
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.resetFields()
                }
            })
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset()
            this.formType = 1
            this.form.sceneType = null
            this.form.sceneData = {}
            this.open = true
            this.formTitle = '新增'
        },
        /** 修改按钮操作 */
        handleUpdate(row, ids) {
            this.reset()
            this.formType = 2
            const id = row ? row.id : ids

            detail({ id }).then(response => {
                const data = response.data || {}

                // 赋值除sceneData外的字段
                Object.keys(data).forEach(key => {
                    if (key !== 'sceneData') {
                        this.$set(this.form, key, data[key])
                    }
                })
                // 处理 countryCode 回显，如果是逗号分隔字符串
                if (data.countryCode) {
                    this.$set(this.form, 'countryCodeList', data.countryCode.split(','))
                } else {
                    this.$set(this.form, 'countryCodeList', [])
                }
                // 解析 sceneData
                let sceneDataObj = {}
                try {
                    sceneDataObj = JSON.parse(data.sceneData || '{}')
                } catch (e) {
                    console.error('sceneData 解析失败', e)
                }

                // 正确设置 sceneData 到 form.sceneData
                this.$set(this.form, 'sceneData', sceneDataObj)

                this.open = true
                this.formTitle = '修改'
            })
        }
        ,
        /** 提交按钮 */
        submitForm: function () {
            this.$refs.form.validate(valid => {
                this.form.sceneData = JSON.stringify(this.form.sceneData)
                if (this.form.countryCodeList && this.form.countryCodeList.length > 0) {
                    this.form.countryCode = this.form.countryCodeList.join(',');
                } else {
                    this.form.countryCode = null;
                }

                if (valid) {
                    this.submitLoading = true
                    if (this.form.id !== undefined && this.form.id !== null) {
                        console.log('表单内容：', this.form)
                        update(this.form).then(response => {
                            this.$message.success(
                                '修改成功',
                                3
                            )
                            this.open = false
                            this.$emit('ok')
                        }).finally(() => {
                            this.submitLoading = false
                        })
                    } else {
                        add(this.form).then(response => {
                            this.$message.success(
                                '新增成功',
                                3
                            )
                            this.open = false
                            this.$emit('ok')
                        }).finally(() => {
                            this.submitLoading = false
                        })
                    }
                } else {
                    return false
                }
            })
        }
    }
}
</script>
  